import { Button, Card, List, Modal, notification } from "antd";
import React, { useEffect, useState } from "react";
import { BASE_API_CONFIG } from "../../util/Api";
import { axiosInstance } from "util/Api";
import { isValidString, isValidElement } from "../../util/ApiHelper";
import { useDispatch, useSelector } from "react-redux";
import { EyeOutlined, LeftOutlined, LockOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { fetchSuccess } from "../../appRedux/actions";
import { fetchStart } from "appRedux/actions/Common";
import ProductCard from "./ProductCard";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import Ratings from "./Ratings";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { isVerifiedFreightEligible } from "../../util/helper";
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

const UserProfile = () => {
  const location = useLocation();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const moment = require("moment");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");
  console.log("id",id)
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = useState(null);
  console.log("selectedData",selectedData)
  const [userProducts, setUserProducts] = useState(null);
  const quotationId = location.state?.quotationIdForRating;
  const ratingReceiverId = id;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const userData = useSelector(({ auth }) => auth?.userData);
  const authUser = useSelector(({ auth }) => auth.userData);
  const userId = userData?.id;
  const [userDetails, setUserDetails] = useState(null);
  
  console.log("userDetails", userDetails);
  
  // Get user's own subscription/trial status
  const isPremiumUser = userDetails?.Subscription === "Premium";
  const isTrialActive = userDetails?.IsTrailActive === true;
  
  // User has premium access if they are premium OR on trial
  const hasPremiumAccess = isPremiumUser || isTrialActive;
  
  const isFreightForwarder =   
                             userData?.businessTypes?.code === 'exporter' ||
                             userData?.businessTypes?.code === 'manufacturer' ||
                             userData?.businessTypes?.code ===  'commission_agent' ||
                             userData?.businessTypes?.code === 'custom_house_agent' ||
                             userData?.businessTypes?.code  ==='shipping_line' ||
                             userData?.businessTypes?.code  ==='customhouseagents_freightforwarder' ||
                             userData?.businessTypes?.code  ==='manufacturer_exporter';
  
  const isSubscribed = [1,2, 3].includes(subscriptionData?.subscription?.planId) && subscriptionData?.isActive;
  const isFreightlogin = userData?.businessTypes?.code === 'freight_forwarder';
  const isFreightsubscribe = [2, 3].includes(subscriptionData?.subscription?.planId) && subscriptionData?.isActive;

  console.log("subscribe",isSubscribed)

  const fetchUserDetails = async () => {
      if (!userId) return;
      
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/users/${userId}`
        );
        console.log("User details from API:", response.data);
        setUserDetails(response.data?.data || response.data);
        
      } catch (err) {
        setError(err.message);
        console.error('User details fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (userId) {
        fetchUserDetails();
      }
    }, [userId]);

  const fetchSubscription = async () => {
      try {
          const response = await axiosInstance.get(
              `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
          );
          setSubscriptionData(response.data);
          console.log("Response from the backend ",response?.data?.subscription?.planId)
  
          if (!response.data.isActive) {
              setShowSubscriptionPlans(true);
          }
          
      } catch (err) {
          setError(err.message);
          console.error('Subscription fetch error:', err);
      } finally {
          setLoading(false);
      }
  };
  
  useEffect(() => {
      fetchSubscription();
  }, [userId]);

  const getUserCall = async (id) => {
    dispatch(fetchStart());
    try {
      const userResponse = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/${id}`
      );
      const userProductResponse = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/products?userId=${id}`
      );
      setUserProducts(userProductResponse?.data?.data?.rows || []);
      setSelectedData(userResponse?.data?.data || null);
      setError(null);
    } catch (err) {
      setSelectedData(null);
      setUserProducts([]);
      setError(err?.response?.data?.description || err.message);
      notification.error({
        message: "Unable to open profile",
        description:
          err?.response?.status === 403
            ? "You do not have permission to view this profile."
            : err?.response?.data?.description ||
              "Failed to load the user profile.",
      });
    } finally {
      dispatch(fetchSuccess());
    }
  };

  console.log("selectedData", selectedData);
  console.log("userProducts", userProducts);
  console.log("subscriptionData", subscriptionData);
  console.log("hasPremiumAccess", hasPremiumAccess);
  
  useEffect(() => {
    if (isValidString(id)) {
      getUserCall(id);
    }
  }, []);

  const ContactInfo = ({ value, label, isSubscribed }) => {
    const [showSubscribeModal, setShowSubscribeModal] = useState(false);
    
    // FIXED: Content should be restricted ONLY if user doesn't have premium access
    // Premium users and trial users should NOT have content blurred
    const shouldRestrict = !hasPremiumAccess;

    const handleClick = () => {
      if (shouldRestrict) {
        setShowSubscribeModal(true);
      }
    };
  
    return (
      <>
        <div 
          onClick={handleClick}
          style={{ 
            cursor: shouldRestrict ? 'pointer' : 'default',
            position: 'relative',
            display: 'inline-block',
            width: '100%'
          }}
        >
          <div style={{ 
            filter: shouldRestrict ? 'blur(4px)' : 'none',
            userSelect: shouldRestrict ? 'none' : 'auto',
            transition: 'filter 0.3s'
          }}>
            {value || '-'}
          </div>

          {shouldRestrict && (
            <Button 
              type="primary" 
              size="small"
              icon={<EyeOutlined />}
              onClick={handleClick}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: 4,
                fontWeight: 500,
                zIndex: 10,
                background: '#1890ff',
                borderColor: '#1890ff'
              }}
            >
              Upgrade to View
            </Button>
          )}
        </div>

        <Modal
          title={<span style={{ fontWeight: 500 }}>Upgrade Required</span>}
          visible={showSubscribeModal}
          onCancel={() => setShowSubscribeModal(false)}
          footer={null}
          centered
          width={380}
          bodyStyle={{ padding: '24px' }}
        >
          <div style={{ textAlign: 'center' }}>
            <LockOutlined style={{ fontSize: 32, color: '#1890ff', marginBottom: 16 }} />
            <h3 style={{ marginBottom: 8, fontWeight: 500 }}>Upgrade Your Plan</h3>
            <p style={{ color: 'rgba(0, 0, 0, 0.65)', marginBottom: 24 }}>
              To view this {label}, please upgrade your subscription plan.
            </p>
            <Button 
              type="primary" 
              block
              onClick={() => {
                history.push('/my-profile');
                setShowSubscribeModal(false);
              }}
              style={{
                height: 40,
                fontWeight: 500
              }}
            >
              View Subscription Plans
            </Button>
          </div>
        </Modal>
      </>
    );
  };

  const data = [
    {
      label: "Joined on",
      value: isValidString(selectedData?.createdAt)
        ? moment(selectedData?.createdAt).format("DD-MMM-YYYY")
        : "-",
    },
    {
      label: "Location",
      value: `${isValidString(selectedData?.city) ? selectedData?.city : ""}${
        isValidString(selectedData?.city) ? "," : ""
      } ${isValidString(selectedData?.country) ? selectedData?.country : "-"}`,
    },
    {
      label: "Email",
      value: (
        <ContactInfo 
          value={selectedData?.email} 
          label="email" 
        />
      ),
    },
    {
      label: "Phone Number",
      value: (
        <ContactInfo 
          value={selectedData?.mobile} 
          label="phone number" 
        />
      ),
    },
    {
      label: "Company Name",
      value: (
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <ContactInfo 
            value={selectedData?.companyName} 
            label="company name" 
          />
          {isVerifiedFreightEligible(selectedData) && (
            <VerifiedFreightTag verifiedFreight={selectedData?.verifiedFreight} />
          )}
        </div>
      ),
    },
    {
      label: "About Company",
      value: isValidString(selectedData?.companyDescription)
        ? selectedData.companyDescription
        : "-",
    },
  ];

  if (!isValidElement(selectedData)) {
    return (
      <Card className="myexim-detail-card" style={{ width: "100%" }}>
        <div className="myexim-table-title">
          <LeftOutlined
            className={"back-icon"}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          User Profile
        </div>
        <div style={{ paddingTop: 24, color: "#666" }}>
          {error || "Profile details are not available."}
        </div>
      </Card>
    );
  }

  return (
    (
      <>
        <Card className="myexim-detail-card" style={{ width: "100%" }}>
          <div className="myexim-table-title">
            <LeftOutlined
              className={"back-icon"}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
            User Profile
          </div>
          <div className={`logo-with-list gx-mt-4 ${isMobile ? 'gx-flex-column' : ''}`}>
            <div style={{ paddingRight: 16 }}>
              {isValidString(selectedData?.companyLogo) && (
                <div className={"logo-container"}>
                  <div className={"logo-image"}>
                    <img
                      alt="..."
                      src={selectedData?.companyLogo}
                      width={isMobile ? '100%' :120}
                      height={isMobile ? '100%' :120}
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item) =>
                  item?.value && (
                    <List.Item className="myexim-details-list">
                      <List.Item.Meta
                        title={<div>{item.label}</div>}
                        description={item.value}
                      />
                    </List.Item>
                  )
                }
              />
            </div>
          </div>
        </Card>
        {userProducts && userProducts?.length ? (
          <ProductCard productsData={userProducts} />
        ) : null}
        <div>
          <Ratings
            ratingReceiverId = {ratingReceiverId}
            quotationId= {quotationId}
          />
        </div>
      </>
    )
  );
};

export default UserProfile;
